module.exports = __webpack_public_path__ + "static/media/shop-icon.6c8f89cc.svg";